import { whichTransitionEvent } from '../utils/dom';

const transitionEndEvent = whichTransitionEvent();

// NOTE:
// Make sure that slidable elements have overflow set to hidden
// and initially closed ones a height set to 0px via CSS

export function slideOpen(
  el,
  duration = 400,
  easing = 'ease-in-out',
  direction = 'vertical'
) {
  return new Promise(resolve => {
    const axis = direction === 'vertical' ? 'height' : 'width';
    el.style.display = 'block';
    const prevValue = el.style[axis];
    el.style[axis] = 'auto';
    const endValue = getComputedStyle(el)[axis];
    el.style[axis] = prevValue;
    /* eslint-disable-next-line no-unused-expressions */
    el.offsetHeight; // force repaint
    el.style.transition = `${axis} ${duration}ms ${easing}`;
    el.style[axis] = endValue;
    el.addEventListener(
      transitionEndEvent,
      function transitionEnd(event) {
        if (event.propertyName === axis) {
          el.removeEventListener(transitionEndEvent, transitionEnd, false);
          el.style.transition = '';
          el.style[axis] = 'auto';
          resolve();
        }
      },
      false
    );
  });
}

export function slideClose(
  el,
  duration = 400,
  easing = 'ease-in-out',
  direction = 'vertical'
) {
  return new Promise(resolve => {
    const axis = direction === 'vertical' ? 'height' : 'width';
    el.style[axis] = getComputedStyle(el)[axis];
    el.style.transition = `${axis} ${duration}ms ${easing}`;
    /* eslint-disable-next-line no-unused-expressions */
    el.offsetHeight; // force repaint
    el.style[axis] = '0px';
    el.addEventListener(
      transitionEndEvent,
      function transitionEnd(event) {
        if (event.propertyName === axis) {
          el.removeEventListener(transitionEndEvent, transitionEnd, false);
          el.style.transition = '';
          el.style.display = 'none';
          resolve();
        }
      },
      false
    );
  });
}
